module.exports = __webpack_public_path__ + "img/undraw_survey_05s5.7a72abc6.svg";